// Elenco delle news
var React = require('react');
import PropTypes from 'prop-types';
import {get} from './Storage';
import { Message} from "mgUiKit";


// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'MGKomodoToolbarComponent';

class KomodoToolbar extends React.Component{
    //displayName: componentName,

    constructor(props) {
        super(props);
    }

    componentDidMount(){
        

     }

    render() {
        if (!AppSettings['perms'].komodo || AppSettings["isPartner"]) {
            return "";
        }
        let msg = AppSettings['label'].KomodoLabelNoCardMessage;
        if(AppSettings['komodo'].card != null && AppSettings['label']!=''){
            msg = AppSettings['label'].KomodoLabelMessage.replace("[CARD]", AppSettings['komodo'].card);
        }
        

        return (
            <>
            
            <Message type="info" align="left" className="komodo-profile">
              
                 <span className="msg-hello komodo-hello">
                    {msg}&nbsp;<a href={AppSettings['komodo'].url}>{AppSettings['label'].KomodoLabelButton}</a>
                </span>

                {/* inserisco il tout per komodo */}
                
                
                {/* 17/01/2022 MV: avevo fatto un html strutturato ma Giulio ha voluto l'&nbsp; */}
                {/* <span className="msg-hello komodo-hello">
                    {msg}
                </span>
                <span className="mesg-link komodo-link">
                    <a href={AppSettings['komodo'].url}><i></i><span>{AppSettings['label'].KomodoLabelButton}</span></a>
                </span> */}
            </Message>
            </>
        )
    }
};
KomodoToolbar.displayName = componentName;
// PropTypes validation
KomodoToolbar.propTypes = {
};

// default props
KomodoToolbar.defaultProps = {
};

KomodoToolbar.contextTypes = {
    userboxOpened: PropTypes.bool
}

export default KomodoToolbar;